import styled from 'styled-components';
import { Text } from '@zillow/constellation-10';
import { fontSizeMixin, FONT_TYPES } from '@zillow/constellation';

export const ZillowNavbarSubSectionLinkDescription = styled(Text)`
    display: flex;
    flex-direction: row;
    font-size: ${fontSizeMixin(FONT_TYPES.bodySmall)};
    width: 100%;
`;
